import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";
import { LogOut, LayoutDashboard, ShieldCheck } from "lucide-react";

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/connexion");
  };

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-white/90 backdrop-blur-md border-b border-slate-200 sticky top-0 z-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3" data-testid="header-logo-link">
            <img src="/assets/logo.png" alt="Mindset'iMMO" className="h-10 w-auto" data-testid="header-logo" />
            <div className="leading-tight">
              <span className="hidden sm:block text-xs text-slate-500 font-medium">Portail</span>
            </div>
          </Link>
          {user && (
            <nav className="flex items-center gap-2">
              <Link to="/tableau-de-bord">
                <Button variant="ghost" size="sm" data-testid="nav-dashboard-link">
                  <LayoutDashboard className="w-4 h-4 mr-2" />
                  <span className="hidden sm:inline">Tableau de bord</span>
                </Button>
              </Link>
              {user.role === "admin" && (
                <Link to="/admin">
                  <Button variant="ghost" size="sm" data-testid="nav-admin-link">
                    <ShieldCheck className="w-4 h-4 mr-2" />
                    <span className="hidden sm:inline">Administration</span>
                  </Button>
                </Link>
              )}
              <div className="hidden md:flex flex-col items-end mr-2 ml-2">
                <span className="text-sm font-medium text-slate-800" data-testid="header-user-name">
                  {user.prenom} {user.nom}
                </span>
                <span className="text-xs text-slate-500">{user.email}</span>
              </div>
              <Button variant="outline" size="sm" onClick={handleLogout} data-testid="logout-button">
                <LogOut className="w-4 h-4 sm:mr-2" />
                <span className="hidden sm:inline">Déconnexion</span>
              </Button>
            </nav>
          )}
        </div>
      </header>
      <main className="max-w-6xl mx-auto px-4 sm:px-6 py-8">{children}</main>
    </div>
  );
}
